/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_List_TitleInputs */

const en_doc_list_title = /** @type {(inputs: Doc_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploaded documents`)
};

const pt_br2_doc_list_title = /** @type {(inputs: Doc_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos enviados`)
};

/**
* | output |
* | --- |
* | "Uploaded documents" |
*
* @param {Doc_List_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_list_title = /** @type {((inputs?: Doc_List_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_List_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_list_title(inputs)
	return pt_br2_doc_list_title(inputs)
});